<template>
  <div>
    <v-simple-table
      fixed-header
      height="300px"
      width="300px"
      class="px-4 ud-table"
      :class="upcomingDues.length ? 'h-100':''"
    >
      <template v-slot:default>
        <thead>
          <tr>
            <!-- <th></th> -->
            <th>Due Date</th>
            <th class="text-right">Due No.</th>
            <th class="text-right">Due</th>
            <th class="text-right">Days</th>
            <th>Scheme</th>
          </tr>
        </thead>
        <tbody v-if="upcomingDues.length">
          <tr v-for="(ud, udIndex) in upcomingDues" :key="ud.udIndex">
            <!-- <td><v-btn outlined color="green" x-small @click="getPaymentConfirmation(false,ud.balance)">Pay</v-btn></td> -->
            <td>{{ normaliseDate(ud.invoiceDate) }}</td>
            <td class="text-right">{{ ud.invoiceNumber.slice(-7) }}</td>
            <td class="text-right">{{ formatNumber(ud.balance) }}</td>
            <td class="text-right">{{ ud.days }}</td>
            <td>{{ ud.schemeName }}</td>
          </tr>
        </tbody>
        <tbody v-else class="h-100">
          <tr class="h-100">
            <td colspan="5" class="h-100">
              <div class="h-100 d-flex flex-column justify-center align-center">
          <img
            src="@/assets/undraw_online_payments_re_y8f2.svg"
            height="150"
            width="150"
            contain
          />
          <h4 class="font-weight-light text-center">Hi {{ userModel.name }},<br/>There're no transactions for you to see yet</h4>
          <v-btn class="mt-3" color="primary" @click="getPaymentConfirmation">Make Payment</v-btn>
        </div>
        </td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import { callApi } from "@/api/others";
import dayjs from "dayjs";
export default {
  components: {},
  data: () => ({
    currentTab: "",
    tab: "",
    upcomingDues: [],
  }),
  props:{
    userModel:{
      type:Object
    }
  },
  mounted() {
    this.getOutstanding();
  },
  methods: {
    getOutstanding() {
      this.$emit("loadingChange", true);
      let url = "/api/wesupport/TransactionDetail/getOutstanding";
      let data = {
        asOn: dayjs().format("YYYY-MM-DD"),
        memberId: this.decryptMemId(),
      };
      callApi(url, "post", data)
        .then((res) => {
          this.upcomingDues = res.data.data;
          this.getTotalDue();
        })
        .catch((err) => {})
        .finally(() => {
          this.$emit("loadingChange", false);
        });
    },
    getTotalDue() {
      let total = this.upcomingDues.reduce(
        (total, curr) => total + curr.balance,
        0
      );
      this.$emit("updateDueTotal", total);
    },
    getPaymentConfirmation(showPendingAmt,amt){
      this.$emit("getPaymentConfirmation",showPendingAmt,amt);
    }
  },
};
</script>
<style>
.ud-table td,
.ud-table th {
  white-space: nowrap;
  padding-inline: 10px !important;
  height: 35px !important;
}
</style>
